export default __webpack_public_path__ + "static/media/landing-page-cover.4823e93c.webp";